import api from './api';

export const getConversations = async (page = 1, pageSize = 10) => {
  const res = await api.get('/messages/conversations', { params: { page, pageSize } });
  return res.data;
};

export const getMessages = async (conversationId: string, page = 1, pageSize = 50) => {
  const res = await api.get(`/messages/conversations/${conversationId}/messages`, { params: { page, pageSize } });
  return res.data;
};